import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=c7d952fe&scoped=true&"
import script from "./ModalHeader.vue?vue&type=script&lang=js&"
export * from "./ModalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d952fe",
  null
  
)

export default component.exports